import Header from "../Component/UserEnd/Header";
import GalleryInner from "../Component/UserEnd/GalleryInner";
import Footer from "../Component/UserEnd/Footer";

function GalleryPage() {
    return (
        <>
            <Header />
            <GalleryInner />
            <Footer />
        </>
    );
}

export default GalleryPage;
